import styled from "styled-components";
import { getWallpaperBgColor } from "../../utils/helpers";

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: fixed;
  overflow: hidden;
  background: ${({ currentBg, segmentBgColor, bgWallpaper, isPattern, wallpaperOverlayColor }) =>
    currentBg === 3 ? segmentBgColor : 'transparent'};

  background-color: ${({
    currentBg,
    segmentBgColor,
    bgWallpaper,
    isPattern,
    wallpaperOverlayColor,
  }) =>
    currentBg === 0 || currentBg === 3
      ? currentBg === 0
        ? segmentBgColor
        : bgWallpaper !== '' && isPattern
        ? getWallpaperBgColor(wallpaperOverlayColor)
        : currentBg === 3 && segmentBgColor === 'transparent'
        ? 'transparent'
        : 'white'
      : 'transparent'};
`;

export const BackgroundImageCover = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: ${({ bgWallpaper }) => `url(${bgWallpaper})`};
  background-size: cover;
  background-position: center;
  opacity: ${({ wallpaperTransparency }) => wallpaperTransparency || 1};
  z-index: 0;
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${({ wallpaperHueColor }) =>
      wallpaperHueColor ?? "#ffffff"};
    opacity: ${({ wallpaperHuePercentage }) =>
      ((wallpaperHuePercentage ?? 0) / 100)};
    mix-blend-mode: multiply;
    pointer-events: none;
  }
`;

export const PatternContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ wallpaperOverlayColor }) => wallpaperOverlayColor};
  opacity: ${({ wallpaperTransparency }) => wallpaperTransparency || 1};
  z-index: 0;
  overflow: hidden;
`; 